// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ModulePlanningLessonResourceViewModel from '../../../../viewModel/resource/ModulePlanningLessonResourceViewModel';
import ModulePlanningLessonResourceDTO from '../../dto/resource/ModulePlanningLessonResourceDTO';

export default abstract class ModulePlanningLessonResourceModel extends BaseModel<ModulePlanningLessonResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get lessonName() { return this.dto.lessonName; }
  set lessonName(value) { this.dto.lessonName = value; }
  /**
  * @type {date-time}
  */
  get startTime() { return this.dto.startTime; }
  set startTime(value) { this.dto.startTime = value; }
  /**
  * @type {date-time}
  */
  get endTime() { return this.dto.endTime; }
  set endTime(value) { this.dto.endTime = value; }
  /**
  * @type {double}
  */
  get duration() { return this.dto.duration; }
  set duration(value) { this.dto.duration = value; }
  /**
  */
  get isPrototype() { return this.dto.isPrototype; }
  set isPrototype(value) { this.dto.isPrototype = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.lessonName = qs.lessonname;
    this.dto.startTime = qs.starttime;
    this.dto.endTime = qs.endtime;
    value = Number.parseFloat(qs.duration);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.duration = value;
    value = qs.isPrototype === 'true' ? true : qs.isprototype;
    value = qs.isPrototype === 'false' ? false : undefined;
    this.dto.isPrototype = value;
  }
}
